import { useState, useRef, useEffect } from "react";
import Box from '@mui/material/Box/Box';
import { Button } from '@mui/material';
import { padTime } from '../../helpers/padTime'
import './Timer.css'
import { motion } from "framer-motion";
import DonateButton from "../Buttons/Donate";

export const Timer: React.FC = () => {
    const [timerDays, setTimerDays] = useState<string>('00')
    const [timerHours, setTimerHours] = useState<string>('00')
    const [timerMinutes, setTimerMinutes] = useState<string>('00')
    const [timerSeconds, setTimerSeconds] = useState<string>('00')

    let interval = useRef<NodeJS.Timeout | null>(null)

    const startsTimer = () => {
        //внести новую дату
        const countdownTime = new Date("June 02 2023 00:00:00").getTime()


        interval.current = setInterval(() => {
            const now = new Date().getTime()
            const distance = countdownTime - now


            const days = padTime(Math.floor(distance / (1000 * 60 * 60 * 24)));
            const hours = padTime(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            const minutes = padTime(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
            const seconds = padTime(Math.floor((distance % (1000 * 60)) / 1000));


            if (distance < 0) {
                //stop our timer
                clearInterval(interval.current as NodeJS.Timeout)

                // по истечении времени скрывает таймер и устанавливает новый закоговок
                const title = window.document.getElementById('titleTimer') as HTMLElement
                title.textContent = 'The event has ended. Thanks for voting!!!'
                const timer = window.document.getElementById('timer') as HTMLElement
                timer.style.display = 'none'

            } else {
                //updaet timer
                setTimerDays(days)
                setTimerHours(hours)
                setTimerMinutes(minutes)
                setTimerSeconds(seconds)
            }

        }, 1000)
    }
    useEffect(() => {
        startsTimer()
        return () => {
            if (interval.current) {
                clearInterval(interval.current);
            }
        }
    })

    // анимация для кнопки донат
    const bottomVariant = {
        initial: {
            scale: [1, 1.1, 1, 1.1, 1],
            boxShadow: '0px 0px 8px rgb(255,255,255)',
            transition: {
                duration: 2,
                ease: "easeInOut",
                times: [0, 0.2, 0.5, 0.8],
                repeat: Infinity,
                repeatDelay: 1,

            }
        }
    }

    return (
        <>
            <div className="timer_title_wrapper">
                <h2 className="timer_title" id='titleTimer'>Until the end of voting event#2</h2>
            </div>
            <div id='timer'>
                <ul className="time_list" >
                    <li className="time_item">
                        <p className="time_count"> {timerDays}</p>
                        <p className="time_count_name">Days</p>
                    </li>
                    <span className="time_divider">:</span>
                    <li className="time_item">
                        <p className="time_count">{timerHours}</p>
                        <p className="time_count_name">Hours</p>
                    </li>
                    <span className="time_divider">:</span>
                    <li className="time_item">
                        <p className="time_count">{timerMinutes}</p>
                        <p className="time_count_name">Minutes</p>
                    </li>
                    <span className="time_divider">:</span>
                    <li className="time_item">
                        <p className="time_count">{timerSeconds}</p>
                        <p className="time_count_name">Seconds</p>
                    </li>
                </ul>
                {/* Заголовок призовой фонд */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 7 }}>

                    <a href="https://send.monobank.ua/jar/9d14fEpemt" target="_blank">
                       <DonateButton/>
                    </a>


                </Box>
            </div>
        </>
    );
};


